import React from "react";
import ReactDOM from "react-dom/client";
import PharmacistDashboard from "./components/PharmacistDashboard/PharmacistDashboard";
import PatientDashboard from "./components/PatientDashboard/PatientDashboard";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Routes>
        <Route path="/" element={<PharmacistDashboard />}></Route>
        <Route path="/patientdashboard" element={<PatientDashboard />}></Route>
      </Routes>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
